var nowOffset;
// Polyfill for performance.now
export function now() {
    var performance = window.performance;
    if (!!(performance && performance.now)) {
        return performance.now();
    }
    else {
        if (typeof nowOffset === 'undefined') {
            var accurateTimingAvailable = !!(performance &&
                performance.timing &&
                performance.timing.navigationStart);
            nowOffset = accurateTimingAvailable
                ? performance.timing.navigationStart
                : Date.now();
        }
        return Date.now() - nowOffset;
    }
}
//# sourceMappingURL=now.js.map